/* eslint-disable */
import post from '../../../RestAPI/fetchData';
import get from '../../../RestAPI/getDataService';
import config from '../../../config/App_data';
const session = JSON.parse(localStorage.getItem('localstorageval')) || {};
const { token, idname } = session;
const payload = {
  token,
  idname,
};
const getQuizDetails = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/quizzes/getQuize`, {
    ...payload,
    ...data,
  });
};

const getQuestionById = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/quizzes/getQuestionsbyid`, {
    ...payload,
    ...data,
  });
};

const checkUserSelectedAnswer = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/quizzes/checkAnswered`, {
    ...payload,
    ...data,
  });
};
const insertUserTimer = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/quizzes/insertTimer`, {
    ...payload,
    ...data,
  });
};
const saveQuizAnswer = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/quizzes/answerQuiz`, {
    ...payload,
    ...data,
  });
};
const saveAttemptStats = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/saveStats`, {
    ...payload,
    ...data,
  });
};

const fetchSavedQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/getFavQuestions`, {
    ...payload,
    ...data,
  });
};
const saveQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/saveQuestion`, {
    ...payload,
    ...data,
  });
};
const deleteSavedQuestion = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/unsaveQuestion`, {
    ...payload,
    ...data,
  });
};

const saveReport = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/reportQuestion`, {
    ...payload,
    ...data,
  });
};
const saveRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/saveGMATRatting`, {
    ...payload,
    ...data,
  });
};

const fetchRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/getGMATRatting`, {
    ...payload,
    ...data,
  });
};

const updateQuestionRating = async (data) => {
  return await post.callAPI(`${config.backend_api}/gmat-focus/question-bank/UpdateGMATRatting`, {
    ...payload,
    ...data,
  });
};

export const apiServices = {
  saveAttemptStats,
  saveQuizAnswer,
  getQuestionById,
  getQuizDetails,
  fetchSavedQuestion,
  saveQuestion,
  deleteSavedQuestion,
  saveReport,
  saveRating,
  fetchRating,
  updateQuestionRating,
  checkUserSelectedAnswer,
  insertUserTimer,
};



// WEBPACK FOOTER //
// ./src/views/GMATFocus/Quizzes/BeginQuiz/ApiServiceProvider.js